var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bg-gray-100 rounded-md px-3 py-2 d-flex align-items-center",
    },
    [
      _c("div", [
        _c("strong", [_vm._v(_vm._s(_vm.worker.name))]),
        _vm._v(" "),
        _c("div", { staticClass: "text-mono text-truncate text-gray-500" }, [
          _vm._v(_vm._s(_vm.formatLicenceId(_vm.worker.id))),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ml-auto" },
        [
          _vm.status === "ERROR"
            ? _c("UiBadge", { attrs: { type: "danger" } }, [
                _vm._v(_vm._s(_vm.$t("remoteMonitoring.device_status.fail"))),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.status === "WAITING"
            ? _c("UiBadge", { attrs: { type: "info" } }, [
                _vm._v(
                  _vm._s(_vm.$t("remoteMonitoring.device_status.waiting"))
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }